<template>
  <div id="app">
    <cart />
    <Navbar />
    <transition name="fade-transition" mode="out-in">
      <router-view class="router-wrapper" />
    </transition>
    <Footer class="footer-wrapper" />
  </div>
</template>

<script>
import Navbar from "./components/Navbar.vue";
import Footer from "./components/Footer.vue";
import Cart from "@/components/Cart.vue";

export default {
  name: "app",
  components: {
    Navbar,
    Footer,
    Cart,
  },
};
</script>

<style lang="scss">
@import "assets/css/normalize.css";
@import "assets/css/webflow.css";
@import url("https://fonts.googleapis.com/css?family=Roboto:300,400,700");
@import url("https://fonts.googleapis.com/css?family=Fira+Sans:200,200i,300,400");

#app {
  font-family: "Roboto", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100%;
  background-color: #071f32;
}

.router-wrapper {
  min-height: 100vh;
  background-color: #f0f0f0;
}

.footer-wrapper {
  min-height: 15vh;
}

.fade-transition-enter-active,
.fade-transition-leave-active {
  transition: 0.25s;
}

.fade-transition-enter,
.fade-transition-leave-to {
  opacity: 0;
}

.w-layout-grid {
  display: grid;
  grid-auto-columns: 1fr;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto auto;
  grid-row-gap: 16px;
  grid-column-gap: 16px;
}

.cool-link {
  display: inline-block;
  color: #fff;
  text-decoration: none;
}

.cool-link::after {
  content: "";
  display: block;
  width: 0;
  height: 2px;
  background: #fff;
  margin-top: 5px;
  transition: width 0.3s;
}

@media (max-width: 476px) {
  .cool-link::after {
    margin-top: 3px;
    margin-bottom: 7px;
  }
}

.cool-link:hover::after,
.cool-link.active::after {
  width: 100%;
}

.nav-link.cool-link.w--current {
  background-color: transparent;
  color: hsla(0, 0%, 100%, 0.75);
}
</style>

<style>
.font-fira {
  font-family: "Fira Sans", sans-serif;
}
</style>
